class EventCenter {
  constructor(dispatcher) {
    this.dispatcher = dispatcher;
  }
  publish = (eventName, ...args) => this.dispatcher.trigger(eventName, ...args);
}

export default EventCenter;
